import React, { useEffect, useReducer } from 'react'

import Header, { IHeader } from 'Pages/auto/series/header'
import Pk, { IPk } from './pk'
import Photos from './photos'
import Models from 'Pages/auto/series/all-car-models'
import PopularContent from './popular-content'
import { getInitState, reducer } from 'Pages/auto/series/store'
import DCarScore from 'Components/series/dcar-score'
import Favour from 'Components/series/favour'
import Community from 'Components/series/community'
import Articles from 'Components/series/articles'
import VideoManual from './video-manual'
import PkList from 'Pages/auto/series/pk-list'
import CarList from 'Components/series/car-list'
import Head from 'next/head'

interface IProps {
  params: IHeader
  seriesId: number
  seriesName: string
  /* 同级车数据 */
  compare: IPk[]
  videoManualData: any
  photosData: any[]
  hasVR?: boolean
}
function CarSeries({
  params,
  seriesId,
  seriesName,
  compare,
  videoManualData,
  photosData,
  hasVR,
}: IProps) {
  const [state, dispatch] = useReducer(reducer, getInitState())

  return (
    <div className="wrapper">
      <Head>
        <link
          rel="canonical"
          href={`https://www.dongchedi.com/auto/series/${seriesId}`}
        />
      </Head>
      <div className="content-wrapper">
        <section className="left-part">
          <Header seriesId={seriesId} hasVR={hasVR} />
          <div className="community">
            <Community
              series_id={String(seriesId)}
              series_name={seriesName}
              motor_id={params.motor_id}
            />
            <Articles series_id={seriesId} />
          </div>
          <Models
            seriesId={seriesId}
            seriesName={seriesName}
            pkCars={state.cars}
            dispatch={dispatch}
          />
          <Photos seriesId={seriesId} photosData={photosData} />
          {/* 视频说明书 */}
          {videoManualData?.data_list?.length !== 0 ? (
            <VideoManual
              seriesId={seriesId}
              type={1}
              videoManualData={videoManualData}
              seriesName={seriesName}
              id={'videoManual'}
            />
          ) : null}
          <PopularContent seriesId={seriesId} />
        </section>
        <section className="right-part">
          <DCarScore series_id={seriesId} className="margin-bottom-83" />
          <Favour className="margin-bottom-8" />
          {compare?.length ? (
            <Pk
              seriesId={seriesId}
              compare={compare}
              className="margin-bottom-8"
            />
          ) : null}
          <CarList series_id={seriesId} className="margin-bottom-8" />
        </section>
      </div>
      {state.showPk && <PkList pkCars={state.cars} dispatch={dispatch} />}
      <style jsx>
        {`
          .wrapper {
            width: 1196px;
            margin: 10px auto 0;
          }
          .content-wrapper {
            display: flex;
          }
          .community {
            width: 868px;
            margin-top: 8px;
            display: flex;
            justify-content: space-between;
          }
          .left-part {
            width: 868px;
            margin-right: 8px;
          }
          .right-part {
            width: 320px;
          }
          :global(.margin-bottom-8) {
            margin-bottom: 8px;
          }
        `}
      </style>
    </div>
  )
}
export default CarSeries
